<h2 mat-dialog-title>{{ 'administration.sync-monitoring.source-drift.dialog.title' | translate }}</h2>

<mat-dialog-content>
	<p class="audit-dialog-target">
		<span class="audit-dialog-label">{{ 'administration.sync-monitoring.source-drift.dialog.table' | translate }}:</span>
		<strong>{{ data.tableName }}</strong>
	</p>

	@if (isLoading) {
		<mat-progress-spinner diameter="18" mode="indeterminate" class="audit-dialog-spinner"></mat-progress-spinner>
	}
	@if (errorKey) {
		<p class="audit-dialog-warning">{{ errorKey | translate }}</p>
	}
	@if (startErrorKey) {
		<p class="audit-dialog-warning" role="alert">{{ startErrorKey | translate }}</p>
	}
	@if (run; as run) {
		<div>{{ 'administration.sync-monitoring.source-drift.last-run' | translate }}: {{ sourceDriftKey('states', run.state) | translate: { value: run.state } }}</div>
		@if (run.reason) {
			<p class="audit-dialog-warning">{{ sourceDriftKey('reasons', run.reason) | translate: { value: run.reason } }}</p>
		}
		<div>{{ 'administration.sync-monitoring.source-drift.started' | translate }}: {{ formatEpoch(run.startedAt) }}</div>
		<div>{{ 'administration.sync-monitoring.source-drift.finished' | translate }}: {{ formatEpoch(run.finishedAt) }}</div>
		<div>{{ 'administration.sync-monitoring.source-drift.ranges-checked' | translate }}: {{ run.rangesChecked ?? '—' }}</div>
		<div>{{ 'administration.sync-monitoring.source-drift.resent' | translate }}: {{ run.resent ?? '—' }}</div>
		<div>{{ 'administration.sync-monitoring.source-drift.expired' | translate }}: {{ run.expired ?? '—' }}</div>
		<div>{{ 'administration.sync-monitoring.source-drift.dialog.attempts' | translate }}: {{ run.attempts ?? '—' }}</div>
		<div>{{ 'administration.sync-monitoring.source-drift.missing-found' | translate }}: {{ missingTotal }}</div>
		<div>{{ 'administration.sync-monitoring.source-drift.extra-found' | translate }}: {{ extraTotal }}</div>

		<table class="audit-dialog-table">
			<thead>
				<tr>
					<th>{{ 'administration.sync-monitoring.source-drift.dialog.span' | translate }}</th>
					<th class="audit-dialog-num">{{ 'administration.sync-monitoring.source-drift.dialog.missing' | translate }}</th>
					<th class="audit-dialog-num">{{ 'administration.sync-monitoring.source-drift.dialog.extra' | translate }}</th>
				</tr>
			</thead>
			<tbody>
				@for (leaf of run.leaves ?? []; track $index) {
					<tr>
						<td>({{ leaf.fromExclusive ?? '—' }}, {{ leaf.toInclusive ?? '—' }}]</td>
						@if (leaf.missing == null && leaf.extra == null) {
							<td colspan="2">{{ 'administration.sync-monitoring.source-drift.dialog.not-read' | translate }}</td>
						} @else {
							<td class="audit-dialog-num">{{ leaf.missing ?? 0 }}</td>
							<td class="audit-dialog-num">{{ leaf.extra ?? 0 }}</td>
						}
					</tr>
					<tr>
						<td colspan="3">
							<div>
								{{ 'administration.sync-monitoring.source-drift.dialog.counts' | translate: { source: leaf.sourceCount ?? '—', coreOne: leaf.coreOneCount ?? '—' } }}
								· {{ 'administration.sync-monitoring.source-drift.dialog.reads' | translate: { count: leaf.reads?.length ?? 0 } }}
								@for (read of leaf.reads ?? []; track $index) {
									<span class="audit-dialog-keys">({{ read.fromExclusive }}, {{ read.toInclusive }}]</span>
								}
							</div>
							@if (leaf.expiryRefused) {
								<div class="audit-dialog-warning">{{ expiryRefusedKey(leaf) | translate: { value: leaf.expiryRefused } }}</div>
							}
							@if (leaf.missingSample?.length) {
								<div class="audit-dialog-note">
									{{ 'administration.sync-monitoring.source-drift.dialog.missing-sample' | translate }}
									<button mat-button type="button" (click)="copy(leaf.missingSample ?? [])">{{ 'administration.sync-monitoring.source-drift.dialog.copy' | translate }}</button>
								</div>
								<div class="audit-dialog-keys">
									@for (key of leaf.missingSample; track key) {
										<span>{{ key }}</span>
									}
								</div>
							}
							@if (leaf.extraSample?.length) {
								<div class="audit-dialog-note">
									{{ 'administration.sync-monitoring.source-drift.dialog.extra-sample' | translate }}
									<button mat-button type="button" (click)="copy(leaf.extraSample ?? [])">{{ 'administration.sync-monitoring.source-drift.dialog.copy' | translate }}</button>
								</div>
								<div class="audit-dialog-keys">
									@for (key of leaf.extraSample; track key) {
										<span>{{ key }}</span>
									}
								</div>
							}
						</td>
					</tr>
				}
			</tbody>
		</table>
	}
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" mat-dialog-close [disabled]="isStarting">{{ 'administration.sync-monitoring.source-drift.dialog.close' | translate }}</button>
	@if (data.canManage) {
		<button mat-flat-button color="primary" type="button" [disabled]="!canStart" (click)="startCheck()">{{ 'administration.sync-monitoring.source-drift.dialog.run' | translate }}</button>
	}
</mat-dialog-actions>
